import { RulesConstants } from '../RulesConstants';
import { RuleUtilsService } from './RuleUtilsService';
import { ToastType } from 'modules/application/misc/ToastService';
import angular from 'angular';
export class RulesService {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN', 'TeamService', '$translate', 'BlipToastService'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN, TeamService, $translate, BlipToastService) {
        'ngInject';
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.TeamService = TeamService;
        this.$translate = $translate;
        this.BlipToastService = BlipToastService;
    }
    /**
     * Add or update and attendant to an application
     * @param application
     * @param attendant
     */
    async set(application, rule) {
        const resource = {
            ownerIdentity: `${application.shortName}@${this.MESSAGINGHUBDOMAIN}`,
        };
        const ruleResource = this.mapConditionExtraProperty(rule);
        // tslint:disable-next-line:forin
        for (const prop in ruleResource) {
            resource[prop] = ruleResource[prop];
        }
        return await this.MessagingHubService.sendCommand({
            method: 'set',
            to: `${RulesConstants.DESTINATION_DESK}${this.MESSAGINGHUBDOMAIN}`,
            type: 'application/vnd.iris.desk.rule+json',
            uri: RulesConstants.BASE_URL,
            resource: resource,
        });
    }
    /**
     * Delete an application attendant
     * @param attendant
     */
    async delete(rule) {
        return await this.MessagingHubService.sendCommand({
            method: 'delete',
            to: `${RulesConstants.DESTINATION_DESK}${this.MESSAGINGHUBDOMAIN}`,
            uri: `${RulesConstants.BASE_URL}/${rule.id}`,
        });
    }
    /**
     * Get rules for this bot
     * @param skip
     * @param take
     */
    async getRules(skip = 0, take = 100) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `${RulesConstants.DESTINATION_DESK}${this.MESSAGINGHUBDOMAIN}`,
            uri: `${RulesConstants.BASE_URL}?$skip=${skip}&$take=${take}`,
        });
    }
    /**
         * Filter rules for this queue
         * @param filter
         * @param skip
         * @param take
         */
    async filterRulesByQueue(queueId, filter = '', skip = 0, take = 100) {
        const { items, total } = await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `${RulesConstants.DESTINATION_DESK}${this.MESSAGINGHUBDOMAIN}`,
            uri: `${RulesConstants.RULE_QUEUE_URL}${encodeURIComponent(queueId)}?$filter=(substringof('${encodeURIComponent(filter)}'%2Ctitle))&$skip=${skip}&$take=${take}`,
        });
        const rules = this.mapRules(items);
        return { rules, total };
    }
    /**
     * Get rules for this queue
     * @param queueId - the queue's ID
     * @param skip
     * @param take
     */
    async getRulesQueue(queueId, skip = 0, take = 100) {
        try {
            const { items, total } = await this.MessagingHubService.sendCommand({
                method: 'get',
                to: `${RulesConstants.DESTINATION_DESK}${this.MESSAGINGHUBDOMAIN}`,
                uri: `${RulesConstants.RULE_QUEUE_URL}${encodeURIComponent(queueId)}?$skip=${skip}&$take=${take}`,
            });
            const rules = this.mapRules(items);
            return { rules, total };
        }
        catch (e) {
            if (e.code != 67) {
                this.showToast('queue-management.errors.cannotLoadRules', ToastType.Danger);
            }
            return { rules: [], total: 0 };
        }
    }
    /**
     * Get information about certain rule
     * @param ruleId - the rule's ID
     */
    async getRule(ruleId) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `${RulesConstants.DESTINATION_DESK}${this.MESSAGINGHUBDOMAIN}`,
            uri: `${RulesConstants.RULE_QUEUE_URL}${ruleId}`,
        });
    }
    /**
     * Get rules according to the filter
     * @param filter
     * @param skip
     * @param take
     */
    async filterRules(filter = '', skip = 0, take = 100) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `${RulesConstants.DESTINATION_DESK}${this.MESSAGINGHUBDOMAIN}`,
            uri: `${RulesConstants.BASE_URL}?$filter=(substringof('${encodeURIComponent(filter)}'%2CTitle))&$skip=${skip}&$take=${take}`,
        });
    }
    async getFilterRules(filter = '', skip = 0, take = 100) {
        try {
            let rules;
            const { items, total } = await this.filterRules(filter, skip, take);
            rules = this.mapRules(items);
            return { rules, total };
        }
        catch (e) {
            console.error(e);
        }
    }
    async fetchRules(application) {
        try {
            let rules;
            const { items } = await this.getRules();
            rules = this.mapRules(items);
            return rules;
        }
        catch (e) {
            console.error(e);
        }
    }
    async fetchTeams(application) {
        let teams = [];
        try {
            const { items } = await this.TeamService.getTeams(application);
            teams = items.map(({ name }) => name);
        }
        catch (e) {
            teams = [RulesConstants.DEFAULT_TEAM_NAME];
        }
        return teams.map(team => ({ value: team, label: team }));
    }
    async showToast(messageReference, type) {
        const msg = await this.$translate(messageReference);
        const toastOptions = { msg, buttonText: await this.$translate('attendance-rules.rules.ok') };
        await this.BlipToastService.show(type, toastOptions);
    }
    mapRules(items) {
        return items.map(item => {
            let rule;
            rule = {
                conditions: item.conditions ?? [{
                        property: item.property,
                        relation: item.relation,
                        values: item.values,
                        extrasProperty: '',
                    }],
                ...item,
                opened: false,
                operator: item.operator || RulesConstants.DEFAULT_OPERATOR,
                repeatConditionsBody: item.conditions?.length > 1,
            };
            rule.conditions = rule.conditions.map((condition) => {
                if (condition.property?.includes(RulesConstants.EXTRAS)) {
                    const prop = RuleUtilsService.convertExtras(condition.property);
                    condition.extrasProperty = prop;
                    condition.property = RulesConstants.CONTACT_EXTRAS;
                }
                return condition;
            });
            return rule;
        });
    }
    mapConditionExtraProperty(rule) {
        if (rule.conditions?.some((condition) => condition.property?.includes(RulesConstants.EXTRAS))) {
            const ruleResource = angular.copy(rule);
            ruleResource.conditions.forEach((condition) => {
                if (condition.property.includes(RulesConstants.EXTRAS)) {
                    condition.property = RuleUtilsService.serializeExtrasProperies(condition.extrasProperty);
                }
            });
            return ruleResource;
        }
        return rule;
    }
}
RulesService.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN', 'TeamService', '$translate', 'BlipToastService'];
